import UserManagementStore from '../../stores/UserManagementStore';
import AccountsStore from '../../stores/AccountsStore/AccountsStore';
import MTrackStore from '../../stores/MTrackStore';
import envConfig from '../../../static/config';
import { isVM } from '../../utils/BrandUtils';

export const shouldShowSecureMessages = () =>
  !UserManagementStore.isAdditionalUser() &&
  !UserManagementStore.isNominatedUser() &&
  (!UserManagementStore.isBusinessUser() ||
    envConfig.isDocumentLibraryEnabled) &&
  envConfig.isSecureMessageEnabled;

export const shouldShowDocumentLib = () =>
  UserManagementStore.isCorporateAdmin() && envConfig.isDocumentLibraryEnabled;

export const shouldShowQuickLinks = () =>
  UserManagementStore.isCorporateAdmin() ||
  UserManagementStore.isAdditionalUser();

export const shouldShowActivateHardTokenSVG = () =>
  UserManagementStore.isSMEUser() || !isVM();

export const isMTrackTileEnabled = () => {
  if (
    UserManagementStore.isBusinessUser() &&
    UserManagementStore.isMTrackUserEnabled()
  ) {
    if (
      AccountsStore.isMTrackProductEnabled() ||
      MTrackStore.isMtrackWhitelisted()
    ) {
      return true;
    }
  }
  return false;
};
